import { Component, Input, OnInit } from '@angular/core';
import { CellDateFormatterComponent } from '../../cell-date-formatter/cell-date-formatter.component';
import { PsCoordinacionProyectoService } from '../../../services/ps-coordinacion-proyecto.service';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { PsCoordinacionProyectoEditComponent } from '../ps-coordinacion-proyecto-edit/ps-coordinacion-proyecto-edit.component';
import { ModalDefaultComponent } from '../../controls/modal-default/modal-default.component';
import { DialogComponent } from '../../dialog/dialog.component';
import { ActivatedRoute } from '@angular/router';
import { PSDatosGeneralesModel } from '../../../models/ps-datos-generales-model';

@Component({
  selector: 'app-ps-coordinacion-proyecto-list',
  templateUrl: './ps-coordinacion-proyecto-list.component.html',
  styleUrls: ['./ps-coordinacion-proyecto-list.component.scss']
})
export class PsCoordinacionProyectoListComponent implements OnInit {

  public rowData: any;
  public columnDefs: any[];
  private gridApi;
  dialogConfig: MatDialogConfig;
  @Input() idps: number;
  @Input() psModel: PSDatosGeneralesModel;

  createColumnDef() {
    const columnDefs = [
      {
        headerName: 'Eliminar', field: 'id', suppressFilter: true, suppressSorting: true,
        template: `<a data-action-type="remove"><i data-action-type="remove" class="fa fa-remove text-danger"></i></a>`,
        width: 100
      },
      {
        headerName: 'Editar', field: 'id', cellClass: 'grid-opendialog',
        template: `<i class="fa fa-edit text-info"></i>`,
        width: 100
      },
      { headerName: 'Nº Hito', field: 'nHito', minWidth: 150 },
      { headerName: 'Descripcion', field: 'descripcion', minWidth: 150 },
      { headerName: 'Fecha prevista hito', field: 'fechaPrevistaHito', cellRendererFramework: CellDateFormatterComponent, minWidth: 150 },
    ];

    return columnDefs;
  }

  constructor(private _psCoordinacionProyectoService: PsCoordinacionProyectoService, private _dialog: MatDialog, private _avRoute: ActivatedRoute,
  ) {
    if (this._avRoute.snapshot.params['id']) {
      this.idps = this._avRoute.snapshot.params['id'];
    }
    this.columnDefs = this.createColumnDef();
  }

  ngOnInit() {
    this.loadData();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  onRowClicked(id: number) {
    this.onEdit(id);
  }

  public onCellClickedEvent($event) {
    if ($event.event.target !== undefined) {
      let data = $event.data;
      let actionType = $event.event.target.getAttribute("data-action-type");

      switch (actionType) {
        case "remove":
          return this.onActionRemoveClick(data);
      }
    }
    if ($event.colDef.cellClass !== undefined && $event.colDef.cellClass.indexOf("grid-opendialog") >= 0) {
      this.onEdit($event.data.id);
    }
  }

  public onEdit(id: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "30%"
    // dialogConfig.height = "30%"
    dialogConfig.data = {
      id: id,
      idps: this.idps,
      isModal: true
    };
    let ref = this._dialog.open(PsCoordinacionProyectoEditComponent, dialogConfig);
    ref.afterClosed().subscribe(result => {
      this.loadData();
    });
  }

  public loadData() {
    this._psCoordinacionProyectoService.getAll(this.idps).subscribe(data => {
      this.rowData = data
    }),
      error => console.error("Error, no se ha podido recuperar datos.");
  }

  onActionRemoveClick(data: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "350px"
    dialogConfig.data = {
      title: 'Atención',
      confirmText: 'Confirmar',
      // classColor: 'button-danger',
      message: `¿Está seguro de querer eliminar este hito?.`,
    };
    const ref = this._dialog.open(ModalDefaultComponent, dialogConfig);
    ref.afterClosed().subscribe(async result => {
      if (result) {
        try {
          this._psCoordinacionProyectoService.delete(data.id).subscribe((data: any) => {
            this.loadData();
          });
        } catch (error) {
          console.error(error);
        }
      } else {
        this.onNoClick();
      }
    });
  }

  onNoClick(): void {
    // this.dialogRef.close(false);
  }

}
